import { Project } from '@/models/projects/project';
import { ProjectZone } from '@/models/projects/project-zone';
import { axiosService } from '.';

export default class ProjectsService {
    public async getProject(id: number): Promise<Project> {
        return new Project((await axiosService.instance.get(`projects/organization/${id}`)).data);
    }

    public async getProjects(): Promise<Project[]> {
        const response = await axiosService.instance.get('projects/organization');
        return response.data.map((project: any) => new Project(project));
    }

    public async getProjectZones(id: number): Promise<ProjectZone[]> {
        const response = await axiosService.instance.get(`projects/organization/${id}/zones`);
        return response.data.map((projectZone: any) => new ProjectZone(projectZone));
    }
}

export const projectsService = new ProjectsService();
